// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"clear"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M14 2L10 2L10 10.5L4 10.5V15L20 15L20 10.5H14L14 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M4 15L4 22L20 22V15L4 15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 15V22H20V15M4 15H20M4 15V10.5H10V2H14V10.5H20V15M15 22V19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-clear')
export default class ClearIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'clear',
    }
  }
}
